import { ReturnComic } from "./ReturnComic";
import React, { useEffect, useState } from "react";
import ComicModel from "../../../models/ComicModel";
import { LoadingSpinner } from "../../utils/LoadingSpinner";
import { Link } from "react-router-dom";
import { config } from './../../../Constants'


export const Carousel = () => {
	const [comics, setComics] = useState<ComicModel[]>([]);
	const [isLoading, setIsLoading] = useState(true);
	const [httpError, setHttpError] = useState(null);

	const API_BASE_URL = config.url.API_HOST

	useEffect(() => {
		const fetchComic = async () => {
			const baseUrl: string = `${API_BASE_URL}/api/comics`;

			const url: string = `${baseUrl}?page=0&size=9`;

			const response = await fetch(url);

			if (!response.ok) {
				console.log("ERROR");
				throw new Error("Something went wrong!");
			}

			const responseJson = await response.json();

			const responseData = responseJson._embedded.comics;

			const loadedComics: ComicModel[] = [];

			responseData.map((item: ComicModel) => {
				loadedComics.push(item);
			});

			setComics(loadedComics);
			setIsLoading(false);
		};

		fetchComic().catch((error: any) => {
			setIsLoading(false);
			setHttpError(error.message);
		});
	}, []);

	if (isLoading) {
		return (
			<LoadingSpinner></LoadingSpinner>
		);
	}

	if (httpError) {
		return (
			<div className="container m-5">
				<p>{httpError}</p>
			</div>
		);
	}

	return (
		<div className="container mt-5" style={{ height: 550 }}>
			<div className="homepage-carousel-title">
				<h3 className="comic-font">Find the next big comic!</h3>
			</div>
			<div
				id="carouselExampleControls"
				className="carousel carousel-dark slide mt-5 d-none d-lg-block"
				data-bs-interval="false"
			>
				{/*Desktop*/}
				<div className="carousel-inner">
					<div className="carousel-item active">
						<div className="row d-flex justify-content-center align-items-center">
							{comics.slice(0, 3).map((comic) => (
								<ReturnComic comic={comic} key={comic.id} />
							))}
						</div>
					</div>

					<div className="carousel-item">
						<div className="row d-flex justify-content-center align-items-center">
							{comics.slice(3, 6).map((comic) => (
								<ReturnComic comic={comic} key={comic.id} />
							))}
						</div>
					</div>

					<div className="carousel-item">
						<div className="row d-flex justify-content-center align-items-center">
							{comics.slice(6, 9).map((comic) => (
								<ReturnComic comic={comic} key={comic.id} />
							))}
						</div>
					</div>
				</div>
				<button
					className="carousel-control-prev"
					type="button"
					data-bs-target="#carouselExampleControls"
					data-bs-slide="prev"
				>
					<span
						className="carousel-control-prev-icon"
						aria-hidden="true"
					></span>
					<span className="virtually-hidden">Previous</span>
				</button>

				<button
					className="carousel-control-next"
					type="button"
					data-bs-target="#carouselExampleControls"
					data-bs-slide="next"
				>
					<span
						className="carousel-control-next-icon"
						aria-hidden="true"
					></span>
					<span className="virtually-hidden">next</span>
				</button>
			</div>
			{/*Mobile*/}
			<div className="d-lg-none mt-3">
			<div className="row d-flex justify-content-center align-items-center">
							{comics.slice(0, 1).map((comic) => (
								<ReturnComic comic={comic} key={comic.id} />
							))}
						</div>
			</div>
			<div className="homepage-carousel-title mt-3">
				<Link className="btn btn-dark btn-lg" to='/search'>View More</Link>
			</div>
		</div>
	);
};
